const getters = {
  getGroupTypes(state) {
    return state.groupTypes;
  },
};

export default getters;
